import $ from 'jquery';

let html = $(
    '<div class="loader-backdrop fade">' +
    '  <div class="spinner-border" role="status">' +
    '    <span class="sr-only">Loading...</span> ' + 
    '  </div>' +
    '</div>');

const PERSISTENT_CLASS = 'persistent';
    
export function show(options) {
    let config = {
        persist: false
    };
    Object.assign(config, options);

    let $body = $(document.body);
    $body.addClass('overflow-hidden'); // hide scrollbar
    $body.append(html);
    $('.loader-backdrop').addClass('show ' + (config.persist ? PERSISTENT_CLASS : ''));
}

/**
 * @param force {boolean}
 */
export function hide(force) {
    let isPersistent = $('.loader-backdrop').hasClass(PERSISTENT_CLASS);
    if (!isPersistent || force) {
        $(document.body).removeClass('overflow-hidden');
        $('.loader-backdrop').removeClass('show').delay(15).remove();
    }
}

export function unpersist() {
    $('.loader-backdrop').removeClass(PERSISTENT_CLASS);
}


// WEBPACK FOOTER //
// ./js/aemps/spinner.js